import React from 'react'

const RoomsGuests = ({
  guestCounterOpen,
  setGuestCounterOpen,
  formData,
  setFormData,
  children
}) => {
  const handleIncrement = type => {
    setFormData(prevData => ({
      ...prevData,
      [type]: Math.min((prevData?.[type] || 0) + 1, type === 'children' ? 8 : 9)
    }))
  }

  const handleDecrement = type => {
    setFormData(prevData => ({
      ...prevData,
      [type]: Math.max((prevData?.[type] || 0) - 1, 0)
    }))
  }
  return (
    <div>
      {guestCounterOpen && (
        <div
          onClick={() => setGuestCounterOpen(false)}
          className='GuestCounter-center'
        ></div>
      )}
      <div
        className='add-room passenger-holder show-adult-child'
        style={{ display: guestCounterOpen ? 'block' : 'none' }}
      >
        <div className='room-add-holder'>
          <div className='room-add1'>
            <div className='row'>
              {(children === 'children'
                ? ['rooms', 'adults']
                : ['adults', 'children', 'rooms']
              ).map((type, index) => (
                <div key={index} className='col-md-4 left-holder'>
                  <p className='adult'>
                    {type === 'rooms'
                      ? 'Infant'
                      : type === 'adults'
                      ? 'Adult'
                      : type === 'Child'
                      ? ''
                      : type.charAt(0).toUpperCase() + type.slice(1)}
                  </p>

                  <div className='count'>
                    <button
                      type='button'
                      className='minus'
                      onClick={() => handleDecrement(type)}
                    >
                      -
                    </button>
                    <input
                      type='text'
                      value={formData?.[type] || 0} // Default to 0 if undefined
                      className='quntity-input'
                    />
                    <button
                      type='button'
                      className='plus'
                      onClick={() => handleIncrement(type)}
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='add-room-btn apply-btn float-right'>
          <button
            className='btn btn-apply'
            onClick={() => setGuestCounterOpen(false)}
          >
            Apply Now
          </button>
        </div>
      </div>
    </div>
  )
}

export default RoomsGuests
